export default {
  id: (state) => state.id,
  formData: (state) => state.formData,
  isLoading: (state) => state.loading,
  isActionLoading: (state) => state.actionLoading,
  sort: (state) => state.sort,
  chronologySort: (state) => state.chronologySort,
  items: (state) => state.items,
  search: (state) => state.search,
  dateRange: (state) => state.dateRange,
  statuses: (state) => state.statuses,
  currentPaymentLink: (state) => state.currentPaymentLink,
  total: (state) => state.total,
  statistics: (state) => state.statistics,
}
